import { object } from "yup";

import { templateAssetValidationSchema } from "@dzambalaorg/mui-inputs-asset";
import { draftValidationSchema, titleValidationSchema } from "@dzambalaorg/yup-rules";

export const validationSchema = object().shape({
  title: titleValidationSchema,
  description: draftValidationSchema,
  price: templateAssetValidationSchema,
});
